import { Component, Input, OnInit } from "@angular/core";
import saveAs from "file-saver";
import { SnackbarService } from "src/app/core/service/snackbar.service";
import { AnexoTO } from "src/app/data/schema/Courses/AnexoTO";
import { ApiDownloadService } from "src/app/data/service/download/download.service";

@Component({
    selector: "app-attachment-file",
    templateUrl: "./attachment-file.component.html",
    styleUrls: ["./attachment-file.component.scss"]
})
export class AttachmentFileComponent implements OnInit {
    @Input("attachment")
    public attachment!: AnexoTO;

    constructor(private downloadService: ApiDownloadService, private snackBar: SnackbarService) {}

    ngOnInit() {}

    public download = (nome: string, url: string) => {
        this.downloadService.download(url).subscribe(
            (response) => {
                if (response) {
                    saveAs(new Blob([response.slice(0)]), nome);
                }
            },
            (error) => {
                this.snackBar.showHttpMessage(error.code, error.message);
            }
        );
    };
}
